// ** React Imports
import { useCallback, useState } from "react";

// ** Third Party Components
import styled, { css } from "styled-components";
import { Swiper, SwiperSlide } from "swiperNew/react";
import { Autoplay } from "swiperNew/modules";
import loadable from "@loadable/component";

// ** Custom Components
import AboutUs from "./AboutUsItem";
const SliderPaginationAlwaysMiddle = loadable(
	() =>
		import(
			"containers/Modal/components/Swipers/SliderPaginationAlwaysMiddle"
		),
	{
		ssr: false,
	}
);

// ** Import Content
import aboutUsContent from "../aboutUsContent";

// ** Swiper styles
import "swiperNew/css";
import { breakpoints } from "styles/grid";

// #####################################################

// ** Deklaracje breakpointów
const MOBILE = breakpoints.phone;
const TABLET = breakpoints.tablet;
const DESKTOP = breakpoints.desktop;

// #####################################################

const StyledSwiper = styled(Swiper)`
	${({ theme: { colors } }) => css`
		.swiper-pagination-bullet {
			background-color: ${colors.grey};
		}
		.swiper-pagination-bullet-active {
			background-color: ${colors.primary};
		}
		.swiper-pagination {
			position: absolute;
			text-align: center;
			transition: 0.3s opacity;
			transform: translate3d(0, 0, 0);
			z-index: 10;
		}
		.swiper-horizontal > .swiper-pagination-bullets,
		.swiper-pagination-bullets.swiper-pagination-horizontal,
		.swiper-pagination-custom,
		.swiper-pagination-fraction {
			bottom: 10px;
			left: 0;
			width: 100%;
		}
	`}
`;

// #####################################################

const AboutUsSection = () => {
	const [aboutUsSwiper, setAboutUsSwiper] = useState(null);
	const [activeSlide, setActiveSlide] = useState(0);

	const renderSlides = useCallback(() => {
		return aboutUsContent.map(({ quote, link, linkName, data, author }) => (
			<SwiperSlide key={link}>
				<AboutUs
					quote={quote}
					link={link}
					linkName={linkName}
					data={data}
					author={author}
				/>
			</SwiperSlide>
		));
	}, [aboutUsContent]);

	// #####################################################

	return (
		<StyledSwiper
			className="noselect"
			slidesPerView={1}
			spaceBetween={20}
			loop={true}
			autoplay={{
				delay: 2500,
				disableOnInteraction: true,
			}}
			modules={[Autoplay]}
			breakpoints={{
				[MOBILE]: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				[TABLET]: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				[DESKTOP]: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			}}
			onSwiper={(swiper) => {
				setAboutUsSwiper(swiper);
			}}
			onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
		>
			{renderSlides()}
			<SliderPaginationAlwaysMiddle
				activeSlide={activeSlide}
				swiper={aboutUsSwiper}
				multiColor
			/>
		</StyledSwiper>
	);
};

export default AboutUsSection;
